module.exports = "<textarea v-model=model :placeholder=placeholder @input=input @keydown=keep></textarea>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TextareaGrowing.vue
 ** module id = 146
 ** module chunks = 0
 **/